<template>
  <div v-if="formData">
    <div class="form-title level2">个人资料</div>
    <FormItem label="姓名（中文）" :prop="code + '.personalInfo.nameZh'" :rules="disabled ? {} : _required('请输入')">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].personalInfo, 'nameZh')">{{ formData[code].personalInfo.nameZh }}</span>
      <Input v-else v-model="formData[code].personalInfo.nameZh" placeholder="请输入" @on-change="onChangeNameZh" />
      <a v-if="disabled && formData[code].personalInfo.nameZh" style="color: #2d8cf0 !important">
        <i
          class="iconfont iconyincang eye-icon eye"
          v-if="!formData[code].personalInfo.eyeShownameZh"
          @click="openEye(formData[code].personalInfo, 'nameZh')"
        ></i>
      </a>
    </FormItem>
    <FormItem label="姓名（拼音）" :prop="code + '.personalInfo.namePinyin'" :rules="disabled ? {} : _required('请输入')">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].personalInfo, 'namePinyin')">{{
        formData[code].personalInfo.namePinyin
      }}</span>
      <Input v-else v-model="formData[code].personalInfo.namePinyin" placeholder="请输入" />
      <a v-if="disabled && formData[code].personalInfo.namePinyin" style="color: #2d8cf0 !important">
        <i
          class="iconfont iconyincang eye-icon eye"
          v-if="!formData[code].personalInfo.eyeShownamePinyin"
          @click="openEye(formData[code].personalInfo, 'namePinyin')"
        ></i>
      </a>
    </FormItem>
    <FormItem
      label="联系电话"
      :prop="code + '.personalInfo.mobile'"
      :rules="disabled || (formData[code].personalInfo.mobile && formData[code].personalInfo.mobile.indexOf('*') != -1) ? {} : _tel()"
    >
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].personalInfo, 'mobile')">{{ formData[code].personalInfo.mobile }}</span>
      <Input v-else v-model="formData[code].personalInfo.mobile" placeholder="请输入" />
      <a v-if="disabled && formData[code].personalInfo.mobile" style="color: #2d8cf0 !important">
        <i
          class="iconfont iconyincang eye-icon eye"
          v-if="!formData[code].personalInfo.eyeShowmobile"
          @click="openEye(formData[code].personalInfo, 'mobile')"
        ></i>
      </a>
    </FormItem>
    <!-- 受保人显示 -->
    <FormItem v-if="code == 'insured'" label="证件类型" :prop="code + '.personalInfo.cardType'" :rules="disabled ? {} : _required('请选择')">
      <lzDicTxt v-if="disabled" :dicCode="formData[code].personalInfo.cardType" dicType="ID_CARD_TYPE"></lzDicTxt>
      <lzDicSelect v-else v-model="formData[code].personalInfo.cardType" dicType="ID_CARD_TYPE" :transfer="true" :clearable="false" />
    </FormItem>
    <FormItem :label="code == 'insured' ? '证件号码' : '身份证号码'" :prop="code + '.personalInfo.idcardNo'" :rules="disabled ? {} : getIdCardRule()">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].personalInfo, 'idcardNo')">{{ formData[code].personalInfo.idcardNo }}</span>
      <Input v-else v-model="formData[code].personalInfo.idcardNo" placeholder="请输入" @on-change="idcardChange($event)">
        <!-- ocr识别按钮 身份证才有 -->
        <idcardOcr
          slot="suffix"
          class="ocr-btn"
          v-if="!disabled && (formData[code].personalInfo.cardType == 1 || !formData[code].personalInfo.cardType)"
          @ok="saveIdcardInfo"
        />
      </Input>
      <a v-if="disabled && formData[code].personalInfo.idcardNo" style="color: #2d8cf0 !important">
        <i
          class="iconfont iconyincang eye-icon eye"
          v-if="!formData[code].personalInfo.eyeShowidcardNo"
          @click="openEye(formData[code].personalInfo, 'idcardNo')"
        ></i>
      </a>
    </FormItem>
    <FormItem label="出生日期" :prop="code + '.personalInfo.birthday'" :rules="disabled ? {} : _required('请选择')">
      <span v-if="disabled">{{ formData[code].personalInfo.birthday | filterTime('YYYY-MM-DD') }}</span>
      <DatePicker
        v-else
        type="date"
        format="yyyy-MM-dd"
        placeholder="选择日期"
        :editable="false"
        :value="formData[code].personalInfo.birthday"
        @on-change="$set(formData[code].personalInfo, 'birthday', $event)"
      ></DatePicker>
    </FormItem>
    <FormItem label="性别" :prop="code + '.personalInfo.gender'" :rules="disabled ? {} : genderRule">
      <span v-if="disabled">{{ formData[code].personalInfo.gender | filterSex }}</span>
      <RadioGroup v-else v-model="formData[code].personalInfo.gender">
        <Radio label="1">男</Radio>
        <Radio label="2">女</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem label="国家或地区" :prop="code + '.personalInfo.nationality'" :rules="disabled ? {} : _required('请选择')">
      <lzDicTxt v-if="disabled" :dicCode="formData[code].personalInfo.nationality" dicType="NATIONAL"></lzDicTxt>
      <lzDicSelect v-else v-model="formData[code].personalInfo.nationality" dicType="NATIONAL" :transfer="true" clearable />
    </FormItem>
    <FormItem label="通行证/护照号码">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].personalInfo, 'passportCode')">{{
        formData[code].personalInfo.passportCode
      }}</span>
      <Input v-else v-model="formData[code].personalInfo.passportCode" placeholder="请输入" />
      <a v-if="disabled && formData[code].personalInfo.passportCode" style="color: #2d8cf0 !important">
        <i
          class="iconfont iconyincang eye-icon eye"
          v-if="!formData[code].personalInfo.eyeShowpassportCode"
          @click="openEye(formData[code].personalInfo, 'passportCode')"
        ></i>
      </a>
    </FormItem>
    <FormItem
      label="电子邮箱"
      :prop="code + '.personalInfo.email'"
      :rules="disabled || (formData[code].personalInfo.email && formData[code].personalInfo.email.indexOf('*') != -1) ? {} : _email()"
    >
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].personalInfo, 'email')">{{ formData[code].personalInfo.email }}</span>
      <lzEmailInput v-else v-model="formData[code].personalInfo.email"></lzEmailInput>
      <a v-if="disabled && formData[code].personalInfo.email" style="color: #2d8cf0 !important">
        <i
          class="iconfont iconyincang eye-icon eye"
          v-if="!formData[code].personalInfo.eyeShowemail"
          @click="openEye(formData[code].personalInfo, 'email')"
        ></i>
      </a>
    </FormItem>
    <FormItem label="婚姻状况" :prop="code + '.personalInfo.maritalStatus'" :rules="disabled ? {} : _required('请选择')">
      <lzDicTxt v-if="disabled" :dicCode="formData[code].personalInfo.maritalStatus" dicType="MARITAL"></lzDicTxt>
      <lzDicSelect v-else v-model="formData[code].personalInfo.maritalStatus" dicType="MARITAL" :transfer="true" clearable> </lzDicSelect>
    </FormItem>
    <FormItem label="吸烟状况" :prop="code + '.personalInfo.smokingStatus'" :rules="disabled ? {} : _required('请选择吸烟状况')">
      <span v-if="disabled">{{ formData[code].personalInfo.smokingStatus | filterSmokingStatus }}</span>
      <RadioGroup v-else v-model="formData[code].personalInfo.smokingStatus">
        <Radio label="1">吸烟</Radio>
        <Radio label="0">非吸烟</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem label="教育程度" :prop="code + '.personalInfo.eduLevel'" :rules="disabled ? {} : _required('请选择')">
      <lzDicTxt v-if="disabled" :dicCode="formData[code].personalInfo.eduLevel" dicType="EDUCATION"></lzDicTxt>
      <lzDicSelect v-else v-model="formData[code].personalInfo.eduLevel" dicType="EDUCATION" :transfer="true" clearable> </lzDicSelect>
    </FormItem>
    <FormItem label="身份证地址" :prop="code + '.personalInfo.idcardAddr'" :rules="disabled ? {} : _required('请输入')">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].personalInfo, 'idcardAddr')">{{
        formData[code].personalInfo.idcardAddr
      }}</span>
      <Input v-else v-model="formData[code].personalInfo.idcardAddr" placeholder="请输入" type="textarea" :autosize="{ minRows: 2 }" />
      <a v-if="disabled && formData[code].personalInfo.idcardAddr" style="color: #2d8cf0 !important">
        <i
          class="iconfont iconyincang eye-icon eye"
          v-if="!formData[code].personalInfo.eyeShowidcardAddr"
          @click="openEye(formData[code].personalInfo, 'idcardAddr')"
        ></i>
      </a>
    </FormItem>
    <FormItem label="现居住地址" :prop="code + '.personalInfo.currentAddr'" :rules="disabled ? {} : _required('请输入')">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].personalInfo, 'currentAddr')">{{
        formData[code].personalInfo.currentAddr
      }}</span>
      <Input v-else v-model="formData[code].personalInfo.currentAddr" placeholder="请输入" type="textarea" :autosize="{ minRows: 2 }" />
      <a v-if="disabled && formData[code].personalInfo.currentAddr" style="color: #a8adb7">
        <i
          class="iconfont iconyincang eye-icon eye"
          v-if="!formData[code].personalInfo.eyeShowcurrentAddr"
          @click="openEye(formData[code].personalInfo, 'currentAddr')"
        ></i>
      </a>
    </FormItem>
    <FormItem label="通讯地址" :prop="code + '.personalInfo.postalAddr'" :rules="disabled ? {} : _required('请输入')">
      <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].personalInfo, 'postalAddr')">{{
        formData[code].personalInfo.postalAddr
      }}</span>
      <Input v-else v-model="formData[code].personalInfo.postalAddr" placeholder="请输入" type="textarea" :autosize="{ minRows: 2 }" />
      <a v-if="disabled && formData[code].personalInfo.postalAddr" style="color: #2d8cf0 !important">
        <i
          class="iconfont iconyincang eye-icon eye"
          v-if="!formData[code].personalInfo.eyeShowpostalAddr"
          @click="openEye(formData[code].personalInfo, 'postalAddr')"
        ></i>
      </a>
    </FormItem>
    <FormItem label="通讯地址邮递区号" :prop="code + '.personalInfo.postalCode'" :rules="disabled ? {} : _num('输入的类型为数字')">
      <span v-if="disabled">{{ formData[code].personalInfo.postalCode }}</span>
      <Input v-else v-model="formData[code].personalInfo.postalCode" placeholder="只能填写数字" />
    </FormItem>
    <FormItem label="供养未成年人数" :prop="code + '.personalInfo.dependentNum'" :rules="_justIntSort('请输入0或正整数', false)">
      <span v-if="disabled">{{ formData[code].personalInfo.dependentNum }}</span>
      <Input v-else v-model="formData[code].personalInfo.dependentNum" placeholder="只能填写数字" />
    </FormItem>

    <div class="form-title level2">健康信息</div>
    <FormItem label="身高（CM）" :prop="code + '.healthInfo.height'" :rules="disabled ? {} : _num('输入的类型为数字')">
      <span v-if="disabled">{{ formData[code].healthInfo.height }}</span>
      <Input v-else v-model="formData[code].healthInfo.height" placeholder="只能填写数字" />
    </FormItem>
    <FormItem label="体重（KG）" :prop="code + '.healthInfo.weight'" :rules="disabled ? {} : _num('输入的类型为数字')">
      <span v-if="disabled">{{ formData[code].healthInfo.weight }}</span>
      <Input v-else v-model="formData[code].healthInfo.weight" placeholder="只能填写数字" />
    </FormItem>

    <div class="form-title level2">{{ code == 'insurant' ? '工作信息' : '学校/工作信息' }}</div>
    <FormItem label="职业">
      <lzDicTxt v-if="disabled" :dicCode="formData[code].workInfo.occupation" dicType="OCCUPATION"></lzDicTxt>
      <lzDicSelect
        v-else
        v-model="formData[code].workInfo.occupation"
        dicType="OCCUPATION"
        :transfer="true"
        clearable
        :filter="code == 'insurant' ? ['1'] : []"
      >
      </lzDicSelect>
    </FormItem>
    <!-- 学生需要必填下面字段 -->
    <template v-if="formData[code].workInfo.occupation">
      <FormItem
        :label="isStudent ? '学校名称' : '公司名称'"
        :prop="code + '.workInfo.company'"
        :rules="$units.formRule.any('请输入', !disabled && isStudent)"
        key="company"
      >
        <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].workInfo, 'company')">{{ formData[code].workInfo.company }}</span>
        <Input v-else v-model="formData[code].workInfo.company" placeholder="请输入" />
        <a v-if="disabled && formData[code].workInfo.company" style="color: #2d8cf0 !important">
          <i class="iconfont iconyincang eye-icon eye" v-if="!formData[code].workInfo.eyeShowcompany" @click="openEye(formData[code].workInfo, 'company')"></i>
        </a>
      </FormItem>
      <FormItem
        :label="isStudent ? '就读学校地址' : '工作地址'"
        :prop="code + '.workInfo.address'"
        :rules="$units.formRule.any('请输入', !disabled && isStudent)"
        key="address"
      >
        <span v-if="disabled" class="descrypt-text" @dblclick="openEye(formData[code].workInfo, 'address')">{{ formData[code].workInfo.address }}</span>
        <Input v-else v-model="formData[code].workInfo.address" placeholder="请输入" type="textarea" :autosize="{ minRows: 2 }" />
        <a v-if="disabled && formData[code].workInfo.address" style="color: #2d8cf0 !important">
          <i class="iconfont iconyincang eye-icon eye" v-if="!formData[code].workInfo.eyeShowaddress" @click="openEye(formData[code].workInfo, 'address')"></i>
        </a>
      </FormItem>
      <!-- 职业是非学生时显示行业种类 -->
      <FormItem label="行业种类" v-if="!isStudent" key="industry">
        <lzDicTxt v-if="disabled" :dicCode="formData[code].workInfo.industry" dicType="INDUSTRY"></lzDicTxt>
        <lzDicSelect v-else v-model="formData[code].workInfo.industry" dicType="INDUSTRY" :transfer="true" clearable> </lzDicSelect>
      </FormItem>
      <FormItem label="邮递区号" :prop="code + '.workInfo.postalCode'" :rules="_num('输入的类型为数字', isStudent)" key="postalCode">
        <span v-if="disabled">{{ formData[code].workInfo.postalCode }}</span>
        <Input v-else v-model="formData[code].workInfo.postalCode" placeholder="只能填写数字" />
      </FormItem>
    </template>
    <div class="form-title level2">
      <span>财务信息</span>
    </div>
    <FormItem label="月收入（HKD）" :prop="code + '.financeInfo.monthlyIncome'" :rules="_num('输入的类型为数字', code == 'insurant')">
      <span v-if="disabled">{{ formData[code].financeInfo.monthlyIncome }}</span>
      <Input v-else v-model="formData[code].financeInfo.monthlyIncome" placeholder="只能填写数字" />
      <div class="info-text" v-if="code == 'insurant'">年缴保费需小于投保人年净收入的40%</div>
    </FormItem>
    <FormItem label="月支出（HKD）" :prop="code + '.financeInfo.monthlyExpense'" :rules="_num('输入的类型为数字', code == 'insurant')">
      <span v-if="disabled">{{ formData[code].financeInfo.monthlyExpense }}</span>
      <Input v-else v-model="formData[code].financeInfo.monthlyExpense" placeholder="只能填写数字" />
    </FormItem>
    <!-- 收入校验结果 -->
    <FormItem :label-width="10" v-if="code == 'insurant'">
      <Alert type="success" v-if="feeCheck">收入校验通过</Alert>
      <Alert type="error" v-else>收入校验未通过</Alert>
    </FormItem>
    <FormItem label="固定资产（HKD）" :prop="code + '.financeInfo.fixedAssets'" :rules="_num('输入的类型为数字', code == 'insurant')">
      <span v-if="disabled">{{ formData[code].financeInfo.fixedAssets }}</span>
      <Input v-else v-model="formData[code].financeInfo.fixedAssets" placeholder="只能填写数字" />
    </FormItem>
    <FormItem label="流动资产（HKD）" :prop="code + '.financeInfo.currentAssets'" :rules="_num('输入的类型为数字', code == 'insurant')">
      <span v-if="disabled">{{ formData[code].financeInfo.currentAssets }}</span>
      <Input v-else v-model="formData[code].financeInfo.currentAssets" placeholder="只能填写数字" />
    </FormItem>
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzEmailInput from '@/components/commons/lzEmailInput';
import lzDicSelect from '@/components/commons/lzDicSelect';
import validUserName from '@/components/commons/validUserName';
import idcardOcr from '@/components/commons/idcardOcr';
import pinyin from 'js-pinyin';
export default {
  mixins: [common],
  components: {
    lzEmailInput,
    lzDicSelect,
    idcardOcr,
    validUserName,
    lzDicTxt
  },
  props: {
    formData: null,
    feeCheck: null,// 收入校验结果
    // insurant-投保人 insured-受保人
    code: null,
    disabled: false
  },
  data() {
    return {
      genderRule: {
        required: true,
        trigger: 'change',
        validator: (rule, value, callback) => {
          const relation = this.formData.insured.personalInfo.relation;
          if (!value) {
            callback(new Error('请选择性别'));
          } else if (this.code == 'insured' && relation == 'SON' && value != '1') {
            callback(new Error('与投保人关系为儿子时，性别只能为男性'));
          } else if (this.code == 'insured' && relation == 'DAUG' && value != '2') {
            callback(new Error('与投保人关系为女儿时，性别只能为女性'));
          } else {
            callback();
          }
        }
      }
    };
  },
  watch: {},
  computed: {
    // 是否是学生
    isStudent() {
      return this.formData[this.code]?.workInfo?.occupation == 1;
    }
  },
  created() { },
  methods: {
    // ocr 信息回调
    saveIdcardInfo(data) {
      const bean = this.formData[this.code].personalInfo;
      this.$set(bean, 'nameZh', data.name);
      this.$set(bean, 'idcardNo', data.num);
      this.$set(bean, 'idcardAddr', data.address);
      this.$set(bean, 'gender', data.sex == '男' ? '1' : '2');
      if (data.birth) {
        this.$set(bean, 'birthday', data.birth.substr(0, 4) + '-' + data.birth.substr(4, 2) + '-' + data.birth.substr(6, 2));
      }
      if (this.code == 'insurant') {
        this.formData.idcardHead1 = [{
          type: 'idcard_head',
          fileName: data.fileName,
          path: data.path
        }]
      } else if (this.code == 'insured') {
        this.formData.idcardHead2 = [{
          type: 'idcard_head',
          fileName: data.fileName,
          path: data.path
        }]
      }
      if (data.pinyin) {
        this.$set(bean, 'namePinyin', data.pinyin);
      } else {
        this.onChangeNameZh();
      }
    },
    // 解密
    openEye(row, code) {
      if (!row['validName' + code]) {
        this.$refs.validUserNameRef.open(row, code);
        return;
      }
      if (!row['eyeShow' + code]) {
        let operationType = {
          // 1-证件号解密  2-手机号解密 3-银行卡号 4-邮箱  5-通讯地址   6-身份证地址 7-居住地地址 8-通行证/护照号码 9-公司/学校名称 10-公司/学校地址
          idcardNo: 1,
          mobile: 2,
          idcardAddr: 6,
          currentAddr: 7,
          postalAddr: 5,
          passportCode: 8,
          company: 9,
          email: 4,
          address: 10,
          namePinyin: 13,
          nameZh: 12
        };
        let customerType = {
          //       用户类型 1-投保人 2-受保人 3-受益人 4-保单第二持有人
          'insurant': '1',
          'insured': '2'
        };
        this.descrypt(
          {
            query: this.formData.reservationId,
            operationType: operationType[code],
            operationFunction: 14,
            customerType: customerType[this.code]
          },
          row,
          code
        ).then(() => {
          this.$set(row, 'eyeShow' + code, true);
        });
      }
    },
    _required() {
      if (this.disabled) {
        return null;
      }
      return this.$units.formRule.required.apply(this, arguments);
    },
    _num() {
      if (this.disabled) {
        return null;
      }
      return this.$units.formRule.num.apply(this, arguments);
    },
    _justIntSort() {
      if (this.disabled) {
        return null;
      }
      return this.$units.formRule.justIntSort.apply(this, arguments);
    },
    _tel() {
      if (this.disabled) {
        return null;
      }
      return this.$units.formRule.tel.apply(this, arguments);
    },
    _email() {
      if (this.disabled) {
        return null;
      }
      return this.$units.formRule.email.apply(this, arguments);
    },
    // 获取身份证规则
    getIdCardRule() {
      if (!this.formData.id && ((this.code == 'insured' && this.formData[this.code].personalInfo.cardType == 1) || this.code == 'insurant')) {
        // 新增时受保人选了身份证或者是投保人 校验证件格式
        return [this.$units.formRule.required('请输入'), this.$units.formRule.IDNumber()];
      } else {
        return this.$units.formRule.required('请输入');
      }
    },
    idcardChange(e) {
      const idNo = e.target.value;
      var pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (pattern.test(idNo)) {
        const birthday = idNo.substr(6, 4) + '-' + idNo.substr(10, 2) + '-' + idNo.substr(12, 2);
        const sex = idNo.substr(16, 1) % 2 == 1 ? '1' : '2';
        this.$set(this.formData[this.code].personalInfo, 'birthday', birthday);
        this.$set(this.formData[this.code].personalInfo, 'gender', sex);
      }
    },
    // 转换拼音
    onChangeNameZh() {
      const py = pinyin.getFullChars(this.formData[this.code].personalInfo.nameZh);
      pinyin.setOptions({
        checkPolyphone: false,
        charCase: 0
      });
      this.$set(this.formData[this.code].personalInfo, 'namePinyin', py);
    }
  }
};
</script>
<style lang="scss" scoped>
.info-text {
  font-size: 12px;
  white-space: nowrap;
  color: #236dff;
}
</style>